import { BRAND_HEADING_SUFFIX } from "@/seo/site";

/**
 * Visually-hidden brand name, rendered INSIDE a page's <h1>.
 *
 * Every indexable page should carry the event brand in its heading so it can rank
 * for a branded query ("BBC rat race"), but the designed headings are short taglines
 * ("Run With Purpose", "Get In Touch"). This appends the brand for search engines and
 * screen readers without altering the visual design — `sr-only` is clip-based, which
 * both Google and assistive tech treat as ordinary content.
 *
 * Usage: <h1>{t("hero.title")}<BrandHeadingSuffix /></h1>
 */
export function BrandHeadingSuffix() {
  return <span className="sr-only">{BRAND_HEADING_SUFFIX}</span>;
}
